import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useFormContextData } from 'pages/authenticationUsers/contexts'

export const usePhotoUpload = () => {
    const [isUploading, setUploading] = useState(false)
    const [error, setError] = useState<string | null>(null)
    const { setFormData } = useFormContextData()
    const navigate = useNavigate()

    const uploadPhoto = async (photo: string | null) => {
        if (!photo) return

        try {
            setUploading(true)
            setError(null)

            const blob = await (await fetch(photo)).blob()

            setFormData((prevData) => ({
                ...prevData,
                photo: blob,
            }))

            toast.success('عکس با موفقیت ثبت شد')
            navigate('/authentication-user/video-capture')
        } catch (err) {
            console.error('Error uploading photo:', err)
            toast.error('خطایی در ثبت عکس پیش آمده')
        } finally {
            setUploading(false)
        }
    }

    return {
        isUploading,
        error,
        uploadPhoto,
    }
}
